// 校验特殊字符
var specialValidate = (rule, value, callback) => {
  // var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
  // if (value.match(reg)) {
  //     callback(new Error("请勿输入表情"));
  // } else {
  callback();
  // }
};
export default {
  formRules: {
    requestReason: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.requestReasonPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      //     min: 1,
      //     max: 40,
      //     message: "长度在 1 到 40 个字符",
      //     trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    businessDepartmentName: {
      required: true,
      message: window.vm.$t('applicationCredit.form.businessDepartmentPlaceholder'),
      trigger: ['change', 'blur'],
    },
    basicCurrencyType: {
      required: true,
      message: window.vm.$t('applicationCredit.form.businessDepartmentPlaceholder'),
      trigger: ['change', 'blur'],
    },
    partnerName: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.partnerNamePlaceholder'),
        trigger: ['change', 'blur'],
      },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    creditCode: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.creditCodePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    legalPerson: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.legalPersonPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    registeredAssets: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.registeredAssetsPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    actualAssets: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.actualAssetsPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    enterpriseType: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.enterpriseTypePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    establishedDate: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.establishedDatePlaceholder'),
        trigger: ['change', 'blur'],
      },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    streetAddress: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.streetAddressPlaceholder'),
        trigger: ['change', 'blur'],
      },
      //{
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    officeAddress: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.officeAddressPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    shareholderStructure: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.shareholderStructurePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    enterpriseProperty: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.enterprisePropertyPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    upstreamAndPayment: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.upstreamAndPaymentPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    downstreamAndPayment: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.upstreamAndPaymentPlaceholder'),
        trigger: ['change', 'blur'],
      },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    tradingModel: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.tradingModelPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    businessRiskJudgement: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.upstreamAndPaymentPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    enterpriseOther: [
      {
        required: false,
        message: window.vm.$t('applicationCredit.form.enterpriseOtherPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    sellsRevenue: {
      required: true,
      message: window.vm.$t('applicationCredit.form.sellsRevenuePlaceholder'),
      trigger: ['change', 'blur'],
    },
    profit: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.profitPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    totalAssets: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.totalAssetsPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    totalDebt: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.totalDebtPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    totalPureAssets: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.totalPureAssetsPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    lastYearFinanceMark: [
      {
        required: false,
        message: window.vm.$t('applicationCredit.form.requestAmountPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    accountType: {
      required: true,
      message: window.vm.$t('applicationCredit.form.accountTypePlaceholder'),
      trigger: ['change', 'blur'],
    },
    creditType: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.creditTypePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    isInsure: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.isInsurePlaceholder'),
        trigger: ['change', 'blur'],
      },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    insureAmount: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.insureAmountPlaceholder'),
        trigger: ['change', 'blur'],
      },
    ],
    requestAmount: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.requestAmountPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    requestPaymentDays: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.requestPaymentDaysPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    validDate: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.validDatePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    invalidDate: [
      {
        required: true,
        message: window.vm.$t('applicationCredit.form.invalidDatePlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    referenceContractNo: [
      {
        required: false,
        message: window.vm.$t('applicationCredit.form.referenceContractNoPlaceholder'),
        trigger: ['change', 'blur'],
      },
      // {
      // min: 1,
      // max: 40,
      // message: "长度在 1 到 40 个字符",
      // trigger: ["change", "blur"]
      // },
      { validator: specialValidate, trigger: ['change', 'blur'] },
    ],
    guaranteeType: [{ required: true, message: '担保方式必填', trigger: ['change', 'blur'] }],
    guarantyDesc: [{ required: true, message: '担保物必填', trigger: ['change', 'blur'] }],
    guaranteePerson: [{ required: true, message: '担保人必填', trigger: ['change', 'blur'] }],
    guaranteePurview: [{ required: true, message: '担保范围必填', trigger: ['change', 'blur'] }],
  },
};
